<template>
    <v-dialog v-model="dialog" width="800" persistent>
        <v-card v-if="item">
            <v-card-title>Cambio de curso</v-card-title>
            <v-card-text>
                <v-card class="mb-5" outlined>
                    <v-card-subtitle>Curso actual</v-card-subtitle>
                    <v-card-text>
                        <h4>Curso : {{ item.student_course.course.name }}</h4>
                        <h4>Nivel : {{ item.student_course.course.level.name }}</h4>
                        <h4>Modalidad : {{ item.student_course.course.modality.name }}</h4>
                    </v-card-text>
                </v-card>

                <v-select v-model="selected_course" label="Selecciona el curso" color="#000" :items="courses" return-object item-text="name" item-color="#000" filled :no-data-text="no_data_text"></v-select>

                <v-card class="mt-1" v-if="selected_course" outlined>
                    <v-card-subtitle>Nuevo curso</v-card-subtitle>
                    <v-card-text>
                        <h4>Curso : {{ selected_course.name }}</h4>
                        <h4>Nivel : {{ selected_course.level.name }}</h4>
                        <h4>Modalidad : {{ selected_course.modality.name }}</h4>
                        <h4>Cantidad de estudiantes : {{ selected_course.number_students }}</h4>
                        <v-simple-table>
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th>Día</th>
                                        <th>Hora inicial</th>
                                        <th>Hora de termino</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(schedule, index) in selected_course.schedule" :key="index">
                                        <td>{{ schedule.day }}</td>
                                        <td>{{ schedule.start_time }}</td>
                                        <td>{{ schedule.end_time }}</td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-card-text>
                </v-card>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text color="#000" @click="() => {$parent.change_course_dialog = false; selected_course = ''}" :disabled="loading">Cancelar</v-btn>
                <v-btn color="#008dd4" dark :loading="loading" @click="submit">Cambiar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>

import iziToast from 'izitoast'

export default {
    props:['dialog','item','courses','post_url'],
    data: () => ({
        no_data_text:"Sin cursos disponibles",
        selected_course:"",
        loading:false,
    }),

    methods:{
        submit:function(){
            if(this.item.student_course.course.name !== this.selected_course.name && this.selected_course !== ""){
                this.loading = true
                let data = {}
                data.user_id   = this.item.id
                data.course_id = this.selected_course.id

                axios.post(this.post_url, data).then(response => {
                    iziToast.success({
                        title:"Correcto",
                        message:"Curso cambiado correctamente",
                        position:"topRight"
                    })

                    this.$parent.getData()
                    this.selected_course = ""
                    this.$parent.change_course_dialog = false

                }).catch(error => {
                    iziToast.error({
                        title:"Error",
                        message:"Ha ocurrido un error en la comunicación con el servidor",
                        position:"topRight"
                    })
                })
            }

            this.loading = false
        }
    }
}
</script>